module.exports = __webpack_public_path__ + "img/miller_karla.8a2f0f3b.png";